

























import { Component, Vue } from 'vue-property-decorator';
interface DrawerItem {
  title: string;
  icon?: string;
  to?: string;
}

@Component
export default class Drawer extends Vue {
  public drawerItems: DrawerItem[];
  constructor() {
    super();
    this.drawerItems = [
      { title: 'QrCodes', icon: 'insert_drive_file', to: '/DeliveryNotesQr' },
      { title: 'Problems', icon: 'notes', to: '/' },
    ];
  }
}
